import { render } from "./StarQuestion.vue?vue&type=template&id=41ef8211"
import script from "./StarQuestion.vue?vue&type=script&lang=js"
export * from "./StarQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__